<template lang="html">
    <section class="create-user">
        <loader :loading="true" v-if="loading"> </loader>
        <div class="create-user-title d-flex align-items-center">
            <i class="fa fa-plus fa-sm"></i> <span>{{ $t("createUser.title") }}</span>
        </div>
        <div class="create-user-search container">
            <div class="msg-search">{{ $t("createUser.msgSearch") }}</div>
            <form class="form-search" v-on:submit.prevent="searchUser">
                <div class="input-search row">
                    <div class="col d-flex align-items-center justify-content-center">
                        <input
                            v-model.trim="obj.email"
                            v-bind:class="!validEmail(obj.email) && obj.emailBlured ? 'is-invalid' : ''"
                            v-on:blur="obj.emailBlured = true;"
                            id="search"
                            type="text"
                        />
                        <ClientColorButton @click="searchUser" :background-color="currentBrand.linksColor">{{
                            $t("createUser.searchIt")
                        }}</ClientColorButton>
                    </div>
                </div>
            </form>

            <div v-if="obj.submitted">
                <div class="msg-create">
                    <template v-if="!newUser">
                        <template v-if="isHasAccessBrand">
                            <p>{{ $t("createUser.hasAccessBrand", { brand: currentBrand.name.toUpperCase() }) }}</p>
                        </template>
                        <template v-else>
                            <p>{{ $t("createUser.updateBrand") }}</p>
                            <p v-for="ub in dataUser.userBrand">
                                <i>{{ ub.brand.name.toUpperCase() }}</i>
                            </p>
                            <p class="mt-5">{{ $t("createUser.confimUpdateBrand", { brand: currentBrand.name.toUpperCase() }) }}</p>
                        </template>
                    </template>
                </div>
                <form class="form-create" v-if="newUser">
                    <div class="container-create">
                        <div class="msg-error-input">{{ msgInput ? $t("createUser.fieldsError") : msgInput }}</div>
                        <div v-for="type in types" :class="'adduser-input m-' + type.name" :key="type.name">
                            <label label-class="label-form" :label-for="type.name"> {{ $t(type.label) }} <span v-if="type.required">*</span> </label>
                            <input
                                v-model.trim="form[type.name]"
                                v-validate="type.required"
                                class=""
                                :id="type.name"
                                type="text"
                                placeholder=""
                                :disabled="isDisabled || type.disabled"
                            />
                        </div>
                        <div v-if="availableSsoLogin.length > 0" class="adduser-input login-options">
                            <label>Auth type</label>
                            <select v-model="form.disableSso">
                                <option v-bind:value="false">{{ availableSsoLogin }}</option>
                                <option v-bind:value="true">Internal Auth</option>
                            </select>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row d-flex justify-content-center mt-5">
                <div class="col d-flex justify-content-center">
                    <ClientColorButton :inactiveColor="true" @click.prevent="backToUsersList" class-name="mr-3">
                        {{ $t(!obj.valid || (!newUser && isHasAccessBrand) ? "createUser.backToUsersList" : "common.cancel") }}
                    </ClientColorButton>
                </div>
                <div class="col d-flex justify-content-center">
                    <ClientColorButton
                        v-if="obj.valid"
                        :inactiveColor="!obj.submitted"
                        :disabled="!obj.submitted"
                        :background-color="currentBrand.linksColor"
                        @click.prevent="createUser"
                    >
                        {{ $t(newUser ? "common.save" : isHasAccessBrand ? "createUser.manageUserRights" : "createUser.yesIConfirm") }}
                    </ClientColorButton>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import httpService from '../../../components/service'
import cacheService from '@/services/cache';
import userService from '@/services/user';
import TryLoadMixin from '@/mixins/TryLoadMixin';
import {mapActions, mapState} from "vuex";
import loader from '@/components/loader/loader';
import {SHORT_DESCRIPTION} from "@/components/history/constants";
import {removeNbsp} from "../../../utils/string";

export default {
    name: 'create-user',
    props: [
        'action'
    ],
    components: {
        loader
    },
    data () {
        return {
            currentBrandName: cacheService.getCurrentBrandName(),
            types: [
                {
                    name: 'mail',
                    type: 'text',
                    placeholder: '',
                    required: 'required',
                    disabled: true,
                    hidden: true,
                    label: 'createUser.labelEmail'
                },
                {
                    name: 'firstname',
                    type: 'text',
                    placeholder: '',
                    required: 'required',
                    disabled: false,
                    hidden: false,
                    label: 'createUser.labelFirstName'
                },
                {
                    name: 'lastname',
                    type: 'text',
                    placeholder: '',
                    required: 'required',
                    disabled: false,
                    hidden: false,
                    label: 'createUser.labelLastName'
                },
                {
                    name: 'brand',
                    type: 'text',
                    placeholder: '',
                    required: '',
                    disabled: true,
                    hidden: false,
                    label: 'createUser.labelBrand'
                }
            ],
            obj: {
                email: '',
                emailBlured: false,
                valid: false,
                submitted: false
            },
            dataUser: '',
            msgForm: '',
            msgInput: '',
            isDisabled: false,
            newUser: false,
            isHasAccessBrand: false,
            availableSsoLogin: '',
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    },
    methods: {
        ...mapActions("user", {addNewUser: "create"}),

        reset() {
            this.form = {
                gender: '',
                mail: '',
                firstname: '',
                lastname: '',
                brand: cacheService.getCurrentBrandName(),
                disableSso: false
            }
            this.msgInput = ''
            this.obj.email = ''
            this.obj.emailBlured = false
            this.obj.valid = false
            this.obj.submitted = false
        },

        backToUsersList() {
            this.$router.push({path: '/users/user-list'});
        },

        /**
         * get Current lang
         * **/
        getCurrentLang () {
            return cacheService.getUserLang()
        },

        /**
         * return true is mail validate
         * **/
        validate () {
            this.obj.emailBlured = true
            this.obj.valid = false
            this.obj.submitted = false
            if (this.validEmail(this.obj.email)) {
                this.obj.submitted = true
                this.obj.valid = true
                return true
            }
        },

        /**
         * Regex email
         * **/
        validEmail (email) {
            const emailRegex = /^([A-Za-z0-9_\-.+])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,})$/
            return emailRegex.test(String(email).toLowerCase())
        },

        /**
         * Response API
         **/
        apiResponse (response) {
            return (response.content) ? response.content.map(v => {
                this.dataUser = v
            }) : ''
        },

        /********************************************************************
         *
         * function search if email exist
         *
         * ******************************************************************/
        async existEmail (email) {
            const objSearch = {
                email: email
            }
            httpService.post('/admin/manager/user/search', JSON.stringify(objSearch)).then(response => {
                // User Not exist
                if (response.code && response.code === 404) {
                    this.isDisabled = false
                    this.isHasAccessBrand = false
                    this.newUser = true
                    this.msgInput = ''
                    this.msgForm = 'InputEmpty'
                    this.apiResponse(response)
                    this.availableSsoLogin = response.availableSsoLogin
                }

                // User exist
                if (response.code && response.code === 200) {
                    this.isDisabled = true
                    this.newUser = false

                    this.apiResponse(response)

                    this.form = {
                        mail: this.dataUser.email,
                        firstname: this.dataUser.firstname,
                        lastname: this.dataUser.lastname,
                        brand: cacheService.getCurrentBrandName(),
                        disableSso: false
                    }

                    // is user has access in this brand
                    let accessBrand = (this.dataUser.userBrand) ? Object.values(this.dataUser.userBrand).filter(result => {
                        return result.brand.id == cacheService.getCurrentBrandId()
                    }) : ''
                    this.isHasAccessBrand = !!(accessBrand.length > 0 || this.dataUser.isSuperAdmin)

                    this.msgForm = (accessBrand.length > 0 || this.dataUser.isSuperAdmin)
                        ? 'hasAccessBrand'
                        : 'updateBrand'
                }
            })
        },

        /********************************************************************
         *
         * Function search user
         *
         ********************************************************************/
        searchUser (evt) {
            evt.preventDefault()
            this.form = {
                mail: this.obj.email,
                firstname: '',
                lastname: '',
                brand: cacheService.getCurrentBrandName(),
                disableSso: false
            }
            if (this.validate()) {
                this.existEmail(this.obj.email)
            }
        },

        async createUser () {
            let user = {
                email: removeNbsp(this.form.email),
                firstname: removeNbsp(this.form.firstname),
                lastname: removeNbsp(this.form.lastname),
                disableSso: false
            }

            if (!this.newUser) {
                if (!this.isHasAccessBrand) {
                    await this.tryLoad(() => userService.update(this.dataUser.id, user));
                    this.dialogSuccess(SHORT_DESCRIPTION.USER_ADDED.replace('{brand}', this.currentBrand.name.toUpperCase()));
                }
                this.$router.push({path: `/users/user/${this.dataUser.id}`});
            } else {
                if (this.form.lastname && this.form.firstname) {
                    this.msgInput = '';
                    user = {
                        lang1iso: cacheService.getUserLang(),
                        email: removeNbsp(this.obj.email),
                        firstname: removeNbsp(this.form.firstname),
                        lastname: removeNbsp(this.form.lastname),
                        disableSso: removeNbsp(this.form.disableSso)
                    };
                    this.tryLoad(() => {
                        this.addNewUser(user).then(res => {
                            this.dialogSuccess(SHORT_DESCRIPTION.USER_CREATED + '<br>' + SHORT_DESCRIPTION.USER_ADDED.replace('{brand}', this.currentBrand.name.toUpperCase()));
                            this.$router.push({path: `/users/user/${res.id}`});
                        })
                    }) ;
                } else {
                    this.msgInput = "fieldsError"
                }
            }
        }

    },
    mixins:[TryLoadMixin]
}
</script>

<style scoped lang="scss">
.create-user {
    width: 100%;
    padding: 30px;
    background-color: #fff;
    &-title {
        color: #6f6f6f;
        span {
            margin-left: 5px;
            font-family: "Oswald", sans-serif;
            text-transform: uppercase;
            font-size: 32px;
        }
    }
    &-search {
        margin: 0 auto;
        .form-search {
            margin: 0 auto;
            padding-bottom: 30px;
            margin-bottom: 30px;
            input {
                width: 100%;
                max-width: 400px;
                height: 40px;
                border: 1px solid black;
                font-size: 15px;
                font-family: "oswald-regular", sans-serif;
                padding: 5px;
                display: inline-block;
                margin-right: 15px;
                &.is-invalid {
                    border-color: red;
                }
                @media (max-width: 992px) {
                    width: 100%;
                    max-width: 350px;
                }
            }
            .fa-search {
                color: #6f6f6f;
            }
        }
        .form-create {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: 0 auto;
            .container-create {
                padding: 20px 0;
                @media (max-width: 992px) {
                    padding: 0;
                }
            }
            label:first-child {
                width: 100px;
                font-size: 16px;
                font-weight: bold;
                font-family: "Oswald", sans-serif;
                display: inline-block;
                margin-right: 20px;
                span {
                    color: red;
                }
            }
            input {
                border: 1px solid black;
                font-size: 15px;
                font-family: "oswald-regular", sans-serif;
                padding: 5px;
                &.is-invalid {
                    border-color: red;
                }
            }
            .adduser-input {
                margin: 10px 0;
                &.m-brand {
                    input {
                        padding: 0;
                        border: none;
                        background: none;
                        color: #6f6f6f;
                        text-transform: uppercase;
                    }
                }
            }
            .input-search {
                /*border: 1px solid red;*/
            }
            .msg-error-input {
                color: red;
                margin: 10px 0 10px 175px;
            }
        }
        .msg-create,
        .msg-search {
            font-size: 16px;
            text-align: center;
            p,
            i {
                font-size: 16px;
            }
        }
        .msg-search {
            margin: 20px 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// CreateUser.vue?782f0c45